import React from "react"
import { Box, Stack, Text } from "@chakra-ui/react"
import { DioboxEvent, Form } from "sharedTypes"
import pluralize from "pluralize"
import FormIntegrationListItem from "./FormIntegrationListItem"

type Entity = "email" | "text"

type Props = {
  event: DioboxEvent
  forms: Form[]
  deletedFormsCount: number
  showFormSubmissionsLink?: boolean
  entity?: Entity
}

const FormIntegrations = ({
  event: { currency }, event, forms, deletedFormsCount, showFormSubmissionsLink, entity = "email",
}:Props) => {
  const formCount = forms.length
  const entityLabel = entity === "email" ? "email" : "text message"

  if (deletedFormsCount > 0) {
    const deletedFormsMessage = entity === "email"
      ? "This email is linked to a form that is no longer available or has been deleted. Review the submit button or any images that link to a form, then connect them to an active form."
      : "This text message is linked to a form that is no longer available or has been deleted. Review any links in the message and update them to point to an active form."

    return (
      <Text color="red.400" fontWeight="semibold">{deletedFormsMessage}</Text>
    )
  }

  return (
    <>
      <Box mb={6}>
        <Text fontSize="lg">This {entityLabel} connects to {formCount} {pluralize("forms", formCount)}:</Text>
      </Box>
      <Stack spacing={7}>
        {forms.map((form) => (
          <FormIntegrationListItem
            key={form.externalId}
            form={form}
            event={event}
            currency={currency}
            showFormSubmissionsLink={showFormSubmissionsLink}
          />
        ))}
      </Stack>
    </>
  )
}

export default FormIntegrations
